<template>
  <div class="layout">
    <router-view/>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { reqRefreshToken } from '@/api/loginAPI';
import { reqUserEnterprise } from '@/api/userAPI';
export default {
  data() {
    return {
      refresh_token: '',
    };
  },
  computed: {
    ...mapGetters('personOptions', ['_isLogin'])
  },
  methods: {
    // 初始化数据
    init() {
      this.refresh_token = this.$route.query.refresh_token || '';
      if (this.refresh_token && !this._isLogin) {
        this.login();
      }
    },
    login() {
      const dataInfo = { "grant_type": "refresh_token", "refresh_token": this.refresh_token};
      reqRefreshToken(dataInfo).then(async (resp) => {
        if (resp.result) {
          await this.$store.dispatch("personOptions/setTokenInfo", resp.data);
          const enterpriseResp = await reqUserEnterprise();
          if (enterpriseResp.result) {
            await this.$store.dispatch("personOptions/setUserEnterprise", enterpriseResp.data);
          }
          this.$router.go(0);
        }
      });
    },
  },
  created () {
    // this.init();
  }
};
</script>

<style lang="scss" scoped>
.layout {
  min-width: var(--container-width);
}
</style>